export default __webpack_public_path__ + "static/media/ico-tentangkami.0ea27d55.webp";